/* ==========================================================================
   Aori K Beauty — skin-quiz.js
   Skin-type selector with MULTI-SELECT objectives. The CTA opens the skin type's
   collection filtered by every selected objective tag (Shopify native
   `filter.p.tag`). Desktop: accordion (one panel open). Mobile: all panels are
   shown as stacked cards (CSS), and selecting objectives still updates each CTA.
   ========================================================================== */
(function () {
  'use strict';

  function buildHref(base, tags) {
    base = base && base.trim() !== '' ? base : '/collections/all';
    if (!tags.length) return base;
    var sep = base.indexOf('?') > -1 ? '&' : '?';
    var qs = tags.map(function (t) { return 'filter.p.tag=' + encodeURIComponent(t); }).join('&');
    return base + sep + qs;
  }

  function initQuiz(section) {
    var panels = [].slice.call(section.querySelectorAll('[data-panel]'));
    var steps = section.querySelector('.quiz__steps');
    if (!panels.length) return;

    function setOpen(panel) {
      panels.forEach(function (p) {
        var open = p === panel;
        p.classList.toggle('is-open', open);
        var toggle = p.querySelector('[data-panel-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        var exp = p.querySelector('.quiz__expanded');
        if (exp) exp.setAttribute('aria-hidden', open ? 'false' : 'true');
      });
      if (steps) steps.classList.add('is-step2');
    }

    function closeAll() {
      panels.forEach(function (p) {
        p.classList.remove('is-open');
        var toggle = p.querySelector('[data-panel-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      });
      if (steps) steps.classList.remove('is-step2');
    }

    function updateCta(panel) {
      var cta = panel.querySelector('[data-cta]');
      if (!cta) return;
      var selected = [].slice.call(panel.querySelectorAll('.quiz__chip.is-selected'));
      var tags = selected
        .map(function (c) { return (c.getAttribute('data-goal-tag') || '').trim(); })
        .filter(function (t) { return t !== ''; });
      var base = panel.getAttribute('data-link') || '';
      cta.href = buildHref(base, tags);
      var ready = selected.length > 0;
      cta.classList.toggle('is-ready', ready);
      cta.textContent = ready ? cta.getAttribute('data-label-ready') : cta.getAttribute('data-label-hint');
    }

    panels.forEach(function (panel) {
      // Accordion toggle (desktop). On mobile panels are always shown via CSS.
      var toggle = panel.querySelector('[data-panel-toggle]');
      if (toggle) {
        toggle.addEventListener('click', function () {
          if (panel.classList.contains('is-open')) closeAll();
          else setOpen(panel);
        });
      }

      // Multi-select objective chips
      panel.querySelectorAll('[data-chip]').forEach(function (chip) {
        chip.addEventListener('click', function (e) {
          e.stopPropagation();
          chip.classList.toggle('is-selected');
          chip.setAttribute('aria-pressed', chip.classList.contains('is-selected') ? 'true' : 'false');
          updateCta(panel);
        });
      });

      // Click empty area of an open panel to close (desktop only)
      panel.addEventListener('click', function (e) {
        if (!panel.classList.contains('is-open')) return;
        if (e.target.closest('[data-chip], [data-cta], a, button')) return;
        closeAll();
      });

      updateCta(panel); // initialise hrefs
    });
  }

  function boot() {
    document.querySelectorAll('[data-skin-quiz]').forEach(initQuiz);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-skin-quiz]');
    if (s) initQuiz(s);
  });
})();
